import React, { useRef, useEffect, useState } from "react";

declare const window: any;

function TownplanningOverlaysContainer({
  colors,
  theme,
  active,
  frame,
  attribute,
  townplanningUrl,
  originalWidth,
  originalHeight,
  attributes,
}: any) {
  const svgRef = useRef<SVGSVGElement | null>(null);
  const [townplanningData, setTownplanningData]: any = React.useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);
  const [currentRadius, setCurrentRadius]: any = useState(5);
  const [decreasing, setDecreasing] = useState(false);

  /* useEffect(() => {
    // Esta función se ejecutará cada 65 milisegundos
    const interval = setInterval(() => {
      // Actualizar el estado basado en el estado anterior
      setCurrentRadius((prevRadius) => {
        if (prevRadius + 1 <= 15 && !decreasing) {
          return prevRadius + 1;
        } else if (prevRadius - 1 >= 5 && decreasing) {
          return prevRadius - 1;
        }
        // Cambiar la dirección de la animación
        setDecreasing((prevDecreasing) => !prevDecreasing);
        return prevRadius; // No cambia el radio si no se cumple ninguna condición
      });
    }, 65);

    // Devolver una función de limpieza para detener el intervalo
    return () => clearInterval(interval);
  }, [decreasing]); */

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${window.hybrid ? "./" : "https://d1bsymnertnea6.cloudfront.net/" }${townplanningUrl}`
        );
        const data = await response.json();
        setTownplanningData(data.townPlanning_coord_file);
      } catch (error) {
        console.error("Error al cargar los datos:", error);
      }
    };

    fetchData();

    const handleResize = () => {
      setScreenWidth(window.innerWidth);
      setScreenHeight(window.innerHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [townplanningUrl]);

  useEffect(() => {
    const svg = svgRef.current;
    if (!svg) return;

    // Limpiar el contenido del SVG
    svg.innerHTML = "";

    function calculateTextDimensions(
      text,
      fontSize = "14px",
      fontFamily = "Montserrat"
    ) {
      // Crear un elemento temporal
      const tempElement = document.createElement("div");

      // Establecer el texto y los estilos del elemento
      tempElement.style.fontSize = fontSize;
      tempElement.style.fontFamily = fontFamily;
      tempElement.style.position = "absolute";
      tempElement.style.visibility = "hidden";
      tempElement.style.whiteSpace = "nowrap"; // Asegura que el texto no se divida en varias líneas
      tempElement.textContent = text;

      // Añadir el elemento al documento para obtener las dimensiones
      document.body.appendChild(tempElement);

      // Obtener las dimensiones del texto
      const width = tempElement.offsetWidth;
      const height = tempElement.offsetHeight;

      // Eliminar el elemento temporal del documento
      document.body.removeChild(tempElement);

      return { width, height };
    }

    // Función para hacer el color más oscuro
    const darkenColor = (color, percent) => {
      const f = parseInt(color.slice(1), 16);
      const t = percent < 0 ? 0 : 255;
      const p = percent < 0 ? percent * -1 : percent;
      const R = f >> 16;
      const G = (f >> 8) & 0x00ff;
      const B = f & 0x0000ff;
      return (
        "#" +
        (
          0x1000000 +
          (Math.round((t - R) * p) + R) * 0x10000 +
          (Math.round((t - G) * p) + G) * 0x100 +
          (Math.round((t - B) * p) + B)
        )
          .toString(16)
          .slice(1)
      );
    };
    // Definir el color de hover
    const hoverColor = darkenColor(colors?.main_buttons, -0.2); // Ajusta el 0.2 según la cantidad de contraste que desees
    

    // Primero, dibujar los planos...
    townplanningData[
      townplanningData.findIndex(
        (indexFrame: any) => indexFrame.frame === frame
      )
    ]?.[attribute]?.forEach((town, idx) => {
      if (town.verts.length > 2) {
        let vertsOrder = ordenarVertices(town.verts);
        const points = vertsOrder.map((coord) => coord.join(",")).join(" ");

        // Crear el elemento <polygon>
        const polygon = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "polygon"
        );
        polygon.setAttribute("points", points);
        polygon.setAttribute(
          "fill",
          hexToRGBA(
            attributes
              .flatMap((objeto) => objeto.values) // Combina todos los arrays de values en uno solo
              .find((value) => value.id === town.id).billboardStroke,
            0.45
          )
        ); // Fondo semitransparente
        polygon.setAttribute(
          "stroke",
          hexToRGBA(
            attributes
              .flatMap((objeto) => objeto.values) // Combina todos los arrays de values en uno solo
              .find((value) => value.id === town.id).billboardStroke,
            0.8
          )
        ); // Borde
        polygon.setAttribute("stroke-width", "2");

        // Añadir el polígono al SVG
        svg.appendChild(polygon);
      }
    });


    //console.log(frame);
    // Luego, dibujar los círculos y el texto...
    townplanningData[
      townplanningData.findIndex(
        (indexFrame: any) => indexFrame.frame === frame
      )
    ]?.[attribute]?.forEach((town, idx) => {
      if (town.verts.length === 2) {
        const adjustedX = town.verts[0];
        const adjustedY = town.verts[1];

        // Calculamos el tamaño del texto y el radio para el círculo
        const tamanoDelTexto = calcularTamanoDelTexto(town.id, 14);
        const radio =
          Math.max(tamanoDelTexto.width, tamanoDelTexto.height) / 10 + 10; // Añadiendo margen

        // Crear y añadir un círculo al SVG con el radio calculado
        /* const circle = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "circle"
        );
        circle.setAttribute("cx", `${adjustedX}`);
        circle.setAttribute("cy", `${adjustedY}`);
        circle.setAttribute("r", radio.toString()); // Usamos la variable 'radio' aquí
        //circle.setAttribute("fill", "#FFFFFF");
        circle.setAttribute("stroke", theme === "Light" ? "#000" : "#fff");
        circle.setAttribute("stroke-width", "2");
        circle.setAttribute("class", `point-town ${theme}`);

        // Añadir el círculo al SVG
        svg.appendChild(circle); */

        // Crear y añadir el texto dentro del círculo
        const text = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "text"
        );
        /* text.setAttribute("x", `${adjustedX}`);
        text.setAttribute("y", `${adjustedY}`);
        text.setAttribute("text-anchor", "middle");
        text.setAttribute("dominant-baseline", "middle");
        text.setAttribute("fill", theme === "Light" ? "#000" : "#fff");
        text.textContent = attributes
          .flatMap((objeto) => objeto.values) // Combina todos los arrays de values en uno solo
          .find((value) => value.id === town.id).value; */

        text.setAttribute("x", `${adjustedX}`);
        text.setAttribute(
          "y",
          `${
            adjustedY -
            (window.functionIsPortrait() && window.functionIsMobileDevice()
              ? 120
              : 40)
          }`
        ); // 40 píxeles por encima del círculo
        text.setAttribute("text-anchor", "middle"); // Centrar el texto horizontalmente
        text.setAttribute("fill", colors?.secondary_text); // Cambiar el color del texto a blanco
        text.setAttribute("cursor", "pointer"); // Agregar cursor: pointer al texto
        text.setAttribute("pointer-events", "visiblefill");
        text.setAttribute(
          "font-size",
          window.functionIsPortrait() && window.functionIsMobileDevice()
            ? "2.25rem"
            : "0.875rem"
        );
        text.setAttribute("font-weight", "600");
        text.textContent = attributes
          .flatMap((objeto) => objeto.values) // Combina todos los arrays de values en uno solo
          .find((value) => value.id === town.id).value;

        const rect = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "rect"
        );
        const textDimensions = calculateTextDimensions(
          text.textContent,
          "18px",
          "Montserrat"
        );
        const textDimensionsMoviil = calculateTextDimensions(
          text.textContent,
          "40px",
          "Montserrat"
        );
        rect.setAttribute(
          "x",
          `${
            adjustedX -
            (window.functionIsPortrait() && window.functionIsMobileDevice()
              ? textDimensionsMoviil.width < 300
                ? 150
                : textDimensionsMoviil.width / 2
              : textDimensions.width < 100
              ? 50
              : textDimensions.width / 2)
          }`
        ); // 50 de margen a la izquierda y derecha del texto
        rect.setAttribute(
          "y",
          `${
            adjustedY -
            (window.functionIsPortrait() && window.functionIsMobileDevice()
              ? 180
              : 60)
          }`
        ); // 60 de margen encima del texto
        rect.setAttribute(
          "width",
          window.functionIsPortrait() && window.functionIsMobileDevice()
            ? textDimensionsMoviil.width < 300
              ? "300"
              : textDimensionsMoviil.width.toString()
            : textDimensions.width < 100
            ? "100"
            : textDimensions.width.toString()
        );
        rect.setAttribute(
          "height",
          window.functionIsPortrait() && window.functionIsMobileDevice()
            ? "90"
            : "30"
        ); // Altura suficiente para el texto
        rect.setAttribute("fill", colors?.main_buttons);
        rect.setAttribute("cursor", "pointer");
        rect.setAttribute("pointer-events", "visiblefill");
        rect.setAttribute(
          "rx",
          window.functionIsPortrait() && window.functionIsMobileDevice()
            ? "3rem"
            : "1rem"
        ); // Border-radius horizontal

        // Añadir eventos de mouse para cambiar el color en hover
        rect.addEventListener("mouseover", () => {
          rect.setAttribute("fill", hoverColor);
        });

        rect.addEventListener("mouseout", () => {
          rect.setAttribute("fill", colors?.main_buttons);
        });
        text.addEventListener("mouseover", () => {
          rect.setAttribute("fill", hoverColor);
        });

        text.addEventListener("mouseout", () => {
          rect.setAttribute("fill", colors?.main_buttons);
        });

        // Agregar el rectángulo al contenedor
        svg.appendChild(rect);

        // Añadir el texto al SVG después de añadir el círculo
        svg.appendChild(text);
      }
    });
  }, [
    townplanningData,
    currentRadius,
    screenWidth,
    screenHeight,
    frame,
    colors,
    attribute,
    theme,
  ]);

  const ordenarVertices = (vertices) => {
    // Función para encontrar el ángulo polar de dos puntos
    const anguloPolar = (origen, punto) => {
      return Math.atan2(punto[1] - origen[1], punto[0] - origen[0]);
    };

    // Encontrar el vértice superior izquierdo (menor y, o en caso de empate, menor x)
    const superiorIzquierdo = vertices.reduce((prev, current) => {
      if (
        current[1] < prev[1] ||
        (current[1] === prev[1] && current[0] < prev[0])
      ) {
        return current;
      }
      return prev;
    });

    // Ordenar los vértices por ángulo polar, de menor a mayor
    const verticesOrdenados = vertices
      .filter((vertice) => vertice !== superiorIzquierdo) // Remover el vértice superior izquierdo
      .sort(
        (a, b) =>
          anguloPolar(superiorIzquierdo, a) - anguloPolar(superiorIzquierdo, b)
      );

    // Agregar el vértice superior izquierdo al inicio y al final para cerrar el polígono
    return [superiorIzquierdo, ...verticesOrdenados, superiorIzquierdo];
  };

  const hexToRGBA = (hex, alpha = 1) => {
    // Elimina el # si está presente
    hex = hex.replace("#", "");

    // Convierte el valor hexadecimal a decimal
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Normaliza los valores de color al rango de 0 a 255
    const alphaNormalized = Math.min(Math.max(alpha, 0), 1);
    const rNormalized = Math.min(Math.max(r, 0), 255);
    const gNormalized = Math.min(Math.max(g, 0), 255);
    const bNormalized = Math.min(Math.max(b, 0), 255);

    // Devuelve el valor RGBA en formato de cadena
    return `rgba(${rNormalized}, ${gNormalized}, ${bNormalized}, ${alphaNormalized})`;
  };

  // Función para estimar el tamaño del texto basado en la longitud del texto y el tamaño de la fuente
  const calcularTamanoDelTexto = (texto, fontSize) => {
    const canvas = document.createElement("canvas");
    const context: any = canvas.getContext("2d");
    context.font = `${fontSize}px sans-serif`; // Asume que usas una fuente sans-serif para el SVG
    const medida = context.measureText(texto);
    return { width: medida.width, height: fontSize }; // La altura es una estimación que podría ajustarse
  };

  return (
    <svg
      ref={svgRef}
      width={screenWidth}
      height={screenHeight}
      preserveAspectRatio="xMidYMid slice"
      viewBox={`0 0 ${originalWidth} ${originalHeight}`}
      style={{
        overflow: "hidden",
        pointerEvents: "none",
        position: "absolute",
        cursor: "pointer",
        top: 0,
      }}
    ></svg>
  );
}

export default TownplanningOverlaysContainer;
